import React, { useEffect, useState } from "react";
import useEventStore from "../stores/EventStore";

export default function EventVoting() {
    const { finalEventDate, abwesend, anwesend, checkboxOne, checkboxTwo,
        setCheckedOne, setCheckedTwo, updateFinalEventDateVote, getIfUserVotedFinalEvent
        , getFinalEventVotesValues
    } = useEventStore();
    const [username, setUsername] = useState(null);
    const [role, setRole] = useState(null);


    useEffect(() => {
        // Benutzername und Rolle aus localStorage abrufen
        const name = localStorage.getItem('username');
        const userRole = localStorage.getItem('role');
        setUsername(name || "");
        setRole(userRole || "");

        getIfUserVotedFinalEvent(name);
        getFinalEventVotesValues();

        const interval = setInterval(async () => {
            try {
                getIfUserVotedFinalEvent(name);
                getFinalEventVotesValues();
            } catch (error) {
                console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
            }
        }, 5000); // polls every 5 seconds
        return () => clearInterval(interval);
    }, []);

    const handleChangeOne = () => {
        setCheckedOne(!checkboxOne);
        if (!checkboxOne) {
            setCheckedTwo(false); // Setze die zweite Checkbox zurück
        }
    };

    const handleChangeTwo = () => {
        setCheckedTwo(!checkboxTwo);
        if (!checkboxTwo) {
            setCheckedOne(false); // Setze die erste Checkbox zurück
        }
    };

    const handleSave = async () => {
        if (!username) {
            alert("Fehler: Benutzername nicht gesetzt. Bitte melden Sie sich an.");
            return;
        }

        const vote = checkboxOne ? 1 : checkboxTwo ? 0 : null;
        if (vote != null) {
            //call
            updateFinalEventDateVote(username, vote);
        } else {
            alert("Bitte wähle eine Option aus.");
        }
        //this.getAttendanceList();
    };


    return (
        <div>
            <div className="overflow-x-auto">
                {finalEventDate ? (
                    <div>
                        <p>{new Date(finalEventDate).toLocaleString()}</p>
                        <div className="checkbox-container">
                            <input
                                type="checkbox"
                                checked={checkboxOne}
                                onChange={handleChangeOne}
                            />
                            <label>Ich nehme teil</label>
                            <i className="fas fa-user"
                                style={{
                                    color: 'green',
                                    marginTop: '-10px',
                                    marginLeft: '11px'
                                }}></i>
                            <p style={{
                                marginTop: '5px',
                                marginLeft: '4px'
                            }}>{anwesend}</p>
                        </div>
                        <div className="checkbox-container">
                            <input
                                type="checkbox"
                                checked={checkboxTwo}
                                onChange={handleChangeTwo}
                            />
                            <label>Ich nehme nicht teil</label>
                            <i className="fas fa-user"
                                style={{
                                    color: 'red',
                                    marginTop: '-10px',
                                    marginLeft: '11px'
                                }}></i>
                            <p style={{
                                marginTop: '5px',
                                marginLeft: '4px'
                            }}>{abwesend}</p>
                        </div>

                        <div>
                            <button onClick={handleSave}>Anwesenheit speichern</button>
                        </div>
                    </div>

                ) : (
                    <p></p>
                )}
            </div>
        </div>
    );
}
